/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { FontIcon } from '@fluentui/react/lib/Icon';
import { Stack, StackItem } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { Text } from '@fluentui/react/lib/Text';
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { useContext } from 'react';
import { ChevronIcon, getThemedIcon, IconName } from '../../../resources/icons/Icons';
import {
    getMenuEntryCellStyles,
    getMenuEntryIconContainerStyles,
    getMenuEntryIconStyles,
    getMenuEntryRightArrowIconContainerStyles,
    getMenuEntryRightArrowIconStyles,
    getMenuEntryTextStyles,
    getMenuTextWrapperStyles,
} from './MobileCreateRequestMenuEntry.styles';

export interface MobileCreateRequestMenuEntryProps {
    iconName: IconName;
    text: string;
    onClick?: () => void;
}

export const MobileCreateRequestMenuEntry: React.FC<MobileCreateRequestMenuEntryProps> = (
    props: MobileCreateRequestMenuEntryProps
): JSX.Element => {
    const { iconName, text } = props;
    const icon = getThemedIcon(iconName);

    const theme: ITheme = useContext(CustomizerContext).customizations.settings.theme;

    return (
        <Stack styles={getMenuEntryCellStyles()} horizontal>
            <StackItem styles={getMenuEntryIconContainerStyles(theme)} verticalFill>
                <div style={getMenuEntryIconStyles()}>{icon}</div>
            </StackItem>
            <StackItem grow verticalFill styles={getMenuTextWrapperStyles(theme)}>
                <Stack horizontal verticalFill horizontalAlign='space-between'>
                    <StackItem align='center'>
                        <Text styles={getMenuEntryTextStyles(theme)} block nowrap>
                            {text}
                        </Text>
                    </StackItem>
                    <StackItem styles={getMenuEntryRightArrowIconContainerStyles()} verticalFill>
                        <FontIcon style={getMenuEntryRightArrowIconStyles(theme)} iconName={ChevronIcon.ChevronRight} />
                    </StackItem>
                </Stack>
            </StackItem>
        </Stack>
    );
};
